import slugify from 'slugify';

import { type Masked, unmask } from '~/contentful/graphql';

import { type GrantSlug_GrantFragment, type GrantTitle_GrantFragment } from './query';

export function getGrantTitle(data: Masked<typeof GrantTitle_GrantFragment>) {
  const { organization } = unmask<typeof GrantTitle_GrantFragment>(data);
  return organization?.name ?? '';
}

export function getGrantSlug(data: Masked<typeof GrantSlug_GrantFragment>) {
  const grant = unmask<typeof GrantSlug_GrantFragment>(data);
  const title = getGrantTitle(grant);
  return createGrantSlug(grant.id ?? '', title);
}

export function getGrantIdFromSlug(slug: string) {
  return slug.slice(slug.lastIndexOf('-') + 1);
}

export function createGrantTitle(id: string, referenceId: string, title: string): string {
  return title.replace(`[${id}] [${referenceId}] `, '').trim() ?? '';
}

export function createGrantSlug(id: string, title: string): string {
  return encodeURIComponent(`${slugify(title, { lower: true })}-${id}`);
}
